"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShelveTemplate = void 0;
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const shelve_1 = require("./shelve");
const MatchTolerance = 0.1;
class ShelveTemplate {
    constructor(segments) {
        this._relativeSegments = [];
        this._vectorPair = []; //TODO：这个数组貌似只用到了第一个
        //用第一条线段的第一个点作为基点
        this._basePoint = segments[0].p0;
        for (let seg of segments) {
            let relativeSeg = new LineSegment_js_1.default(seg.p0.x - this._basePoint.x, seg.p0.y - this._basePoint.y, seg.p1.x - this._basePoint.x, seg.p1.y - this._basePoint.y);
            this._relativeSegments.push(relativeSeg);
            this._vectorPair.push(new VectorPair(relativeSeg));
        }
    }
    initMatchGroupByFirstSegment(segments) {
        let matchGroups = new Array();
        for (let seg of segments) {
            if (this._vectorPair[0].isSegmentMatched(seg)) { //这里有可能会有正反的问题
                matchGroups.push(new shelve_1.Shelve(seg));
            }
        }
        return matchGroups;
    }
    matchTheRestSegments(segments, matchGroup, isLineSegmentUsed) {
        let isLineSegmentUsedOfThis = new Array(segments.length).fill(false);
        for (let i = 1; i < this._relativeSegments.length; i++) {
            let targetRelativeSegment = this._relativeSegments[i];
            let firstSegment = matchGroup._segments[0];
            let targetSegment = new LineSegment_js_1.default(targetRelativeSegment.p0.x + firstSegment.p0.x, targetRelativeSegment.p0.y + firstSegment.p0.y, targetRelativeSegment.p1.x + firstSegment.p0.x, targetRelativeSegment.p1.y + firstSegment.p0.y);
            let matched = false;
            for (let j = 0; j < segments.length; j++) {
                if (isLineSegmentUsed[j] === true)
                    continue;
                if (this.isTwoSegmentEquals(targetSegment, segments[j])) {
                    matchGroup.add(segments[j]);
                    matched = true;
                    isLineSegmentUsedOfThis[j] = true;
                    break;
                }
            }
            if (!matched) {
                return false;
            }
        }
        //将用过的线段标记为已使用
        for (let i = 0; i < isLineSegmentUsedOfThis.length; i++) {
            if (isLineSegmentUsedOfThis[i] === true) {
                isLineSegmentUsed[i] = true;
            }
        }
        //如果所有线段都能匹配上，则判断为成功
        return true;
    }
    isTwoSegmentEquals(seg1, seg2) {
        return seg1.p0.equals2D(seg2.p0, MatchTolerance) && seg1.p1.equals2D(seg2.p1, MatchTolerance) || seg1.p0.equals2D(seg2.p1, MatchTolerance) && seg1.p1.equals2D(seg2.p0, MatchTolerance);
    }
}
exports.ShelveTemplate = ShelveTemplate;
class VectorPair {
    constructor(segment) {
        this._vector1 = new Vector2D_js_1.default(segment.p0, segment.p1);
        this._vector2 = this._vector1.negate();
    }
    isSegmentMatched(segment) {
        let vec = new Vector2D_js_1.default(segment.p0, segment.p1);
        return this.isTwoVectorEquals(vec, this._vector1) || this.isTwoVectorEquals(vec, this._vector2);
    }
    isTwoVectorEquals(vec1, vec2) {
        return Math.abs(vec1.getX() - vec2.getX()) < MatchTolerance && Math.abs(vec1.getY() - vec2.getY()) < MatchTolerance;
    }
}
